import { IBookingCalendarStore } from '../../index'
import { ISelectTab } from '../../../../actions/bookingCalendar/reservationModal/selectReservationTab'

export default function(
  state: IBookingCalendarStore,
  action: ISelectTab,
): IBookingCalendarStore {
  return {
    ...state,
    reservationModal: {
      ...state.reservationModal,
      selectedTab: action.tab,
    },
  }
}
